import { Injectable } from '@angular/core';
import { RequestMethod, SgWebHttpClient } from '@ds/ng-wt-helpers/http';
import { getQueryParams } from 'src/app/common/utilities/query-params.util';
import { LoginDetailsService } from 'src/app/core/login/services/login-details.service';
import { PLAYER_INFORMATION_URL, UPDATE_PLAYER_INFORMATIN_URL, VALIDATE_PLAYER_PIN_URL } from '../constants/player-information.constants';
import { PlayerInformation, PlayerInformationRequestModel, PlayerUpdateInformation, PlayerUpdateResponse, ValidatePlayerPin } from '../interfaces/player-information.interface';

@Injectable({
  providedIn: 'root'
})
export class PlayerInformationService {
  constructor(private http: SgWebHttpClient,
      private loginDetailsService: LoginDetailsService
    ) { }

  getPlayerInformation(){
    let playerId = this.loginDetailsService.playerId;
    let informationQueryParams: PlayerInformationRequestModel = {
      'property-id': this.loginDetailsService.propertyId,
      'client-id': this.loginDetailsService.clientId,
      fields: 'profile,club,phones,addresses,emails,identifications,stops',
      'trans-employee': this.loginDetailsService.transEmployee,
      'trans-employee-role': this.loginDetailsService.transEmployeeRole,
      'trans-location': this.loginDetailsService.transLocation
    }
    let queryParameters = getQueryParams(informationQueryParams);
    let playerInformationUrl = this.loginDetailsService.baseUrl + PLAYER_INFORMATION_URL(playerId, this.loginDetailsService.tenantCode, queryParameters);

    return this.http.restAPIAsync<PlayerInformation>(
      RequestMethod.GET,
      playerInformationUrl
    );
  }

  getPlayerInformationForCoin(){
    let playerId = this.loginDetailsService.playerId;
    let informationQueryParams: PlayerInformationRequestModel = {
      'property-id': this.loginDetailsService.propertyId,
      'client-id': this.loginDetailsService.clientId,
      fields: 'profile,club,phones,addresses,emails,identifications,stops',
      'trans-employee': this.loginDetailsService.transEmployee,
      'trans-employee-role': this.loginDetailsService.transEmployeeRole,
      'trans-location': this.loginDetailsService.transLocation,
      'account-id': 'Coins_Promo2'
    }
    let queryParameters = getQueryParams(informationQueryParams);
    let playerInformationUrl = this.loginDetailsService.baseUrl + PLAYER_INFORMATION_URL(playerId, this.loginDetailsService.tenantCode, queryParameters);

    return this.http.restAPIAsync<PlayerInformation>(
      RequestMethod.GET,
      playerInformationUrl
    );
  }

  validatePlayerPin(validatePinQuery:ValidatePlayerPin) {
    let playerId = this.loginDetailsService.playerId;
    let validatePinUrl = this.loginDetailsService.baseUrl + VALIDATE_PLAYER_PIN_URL(playerId, this.loginDetailsService.tenantCode);

    const requestBody = {
      'metadata': this.loginDetailsService.getMetaData(),
      'data': validatePinQuery
    }

    return this.http.restAPIAsync<PlayerUpdateResponse>(
      RequestMethod.POST,
      validatePinUrl,
      {
        body: requestBody
      }
    );
  }

  updatePlayerInformation(updatePlayerInformation: Partial<PlayerUpdateInformation>) {
    let playerId = this.loginDetailsService.playerId;
    let updateInformationUrl = this.loginDetailsService.baseUrl + UPDATE_PLAYER_INFORMATIN_URL(playerId, this.loginDetailsService.tenantCode);

    const requestBody = {
      'metadata': this.loginDetailsService.getMetaData(),
      'data': updatePlayerInformation
    }

    return this.http.restAPIAsync<PlayerUpdateResponse>(
      RequestMethod.PATCH,
      updateInformationUrl,
      {
        body: requestBody
      }
    );
  }
}
